import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Detail from './components/Detail';
import {
  getPartnerShopDetail,
  type PartnerShopDetailPageData,
} from '@/api/partnerShopDetail';

export default function YangbokV5TestPage(props: {
  pageData?: PartnerShopDetailPageData;
  shopSlug?: string;
}) {
  const params = useParams<{ shopSlug?: string }>();

  const shopSlug =
    props.shopSlug ||
    params.shopSlug ||
    'hehehe';
  const [pageData, setPageData] = useState<PartnerShopDetailPageData | null>(
    props.pageData || null
  );
  const [loading, setLoading] = useState(!props.pageData);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (props.pageData) {
      setPageData(props.pageData);
      setLoading(false);
      return;
    }

    let ignore = false;

    async function loadDetail() {
      setLoading(true);
      setErrorMessage('');

      try {
        const result = await getPartnerShopDetail(shopSlug, {
          preview: true,
        });

        if (!ignore) {
          setPageData(result);
        }
      } catch (error) {
        console.error('[YangbokV5TestPage] failed to load partner shop detail', error);

        if (!ignore) {
          setErrorMessage(
            error instanceof Error
              ? error.message
              : '업체 상세 정보를 불러오지 못했습니다.'
          );
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    }

    loadDetail();

    return () => {
      ignore = true;
    };
  }, [props.pageData, shopSlug]);

  if (loading) {
    return (
      <div className="min-h-[100dvh] bg-[#F7F2EA] flex items-center justify-center">
        <p className="text-sm text-[#536079]">업체 정보를 불러오는 중입니다.</p>
      </div>
    );
  }

  if (errorMessage || !pageData) {
    return (
      <div className="min-h-[100dvh] bg-[#F7F2EA] flex items-center justify-center px-6">
        <div className="bg-white rounded-2xl p-6 text-center">
          <p className="text-sm font-semibold text-[#121B35]">
            업체 정보를 불러오지 못했습니다.
          </p>
          <p className="text-xs text-[#536079] mt-2">
            {errorMessage || '잠시 후 다시 시도해 주세요.'}
          </p>
        </div>
      </div>
    );
  }

  return <Detail {...pageData} />;
}